import React, { Component } from "react";
import moment from "moment";
import { TextInputSkeleton } from "carbon-components-react";
import Modal from "@acadia-ui/modal";
import ErrorHelpers from "../../Components/FormBuilder/ErrorHelpers";
import FormBuilderV2 from "../../Components/FormBuilder/FormBuilderV2";
import { putPackages } from "../../Flux/Actions/PackagesActions";
import UpdateStateHelper from "../../Components/FormBuilder/UpdateStateHelper";
import ModalHelpers from "./ModalHelpers";
import PackagesDataStore from "../../Flux/Stores/PackagesDataStore";
import MasterCampaignsStore from "../../Flux/Stores/MasterCampaignsStore";
import BookFiltersStore from "../../Flux/Stores/BookFiltersStore";
import "./modal.scss";
import "./NewPackage.scss";
import Loading from "../../Components/LoadingSpinner";
import Button from "@acadia-ui/button";
import { showToast, TOAST_TYPE, ToastNotification } from "@acadia-ui/toast";
import { fetchPlacementConfig } from "../../Flux/Actions/PlacementActions";

const initialState = {
	formData: {},
	postData: {},
	errors: {},
	showErrors: false,
	valueToCalculate: null,
	isFormDataValid: false
};

const formEl = "create_package";

class CreatePackage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			metaData: {
				StartDate: this.props.metaData.StartDate ? moment(this.props.metaData.StartDate).format("YYYY/MM/DD") : null,
				EndDate: this.props.metaData.EndDate ? moment(this.props.metaData.EndDate).format("YYYY/MM/DD") : null
			},
			loading: false,
			...initialState
		};
	}

	componentDidMount() {
		this.props.newPackage(this);
		PackagesDataStore.on("packages_fail", this.handleErrors);
		PackagesDataStore.on("package__errors__reset", this.handleReset);
		PackagesDataStore.on("packages_success", this.handleSuccess);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.config !== this.props.config) {
			this.setInitialFormData();
		}
		this.isValidFormData();
	}

	componentWillUnmount() {
		this.props.newPackage(undefined);
		PackagesDataStore.removeListener("packages_fail", this.handleErrors);
		PackagesDataStore.removeListener("package__errors__reset", this.handleReset);
		PackagesDataStore.removeListener("packages_success", this.handleSuccess);
	}

	handleSuccess = async () => {
		const filterChoices = BookFiltersStore.getChoicesState();
		const placementChoices = JSON.parse(JSON.stringify(filterChoices));
		const parentCampaignUniqueID = MasterCampaignsStore.getParentCampaignUniqueID();
		placementChoices.auditlevel = { value: this.props.auditLevelID };
		await this.props.updateCounts("Package");
		await fetchPlacementConfig(placementChoices, parentCampaignUniqueID);

		// setTimeout(() => {
		this.setState({ loading: false }, () => {
			this.triggerOpenClose();
		});
		showToast("workbookToasts", <ToastNotification type={TOAST_TYPE.SUCCESS} message="Package added successfully." timed={5000} />);
		// }, 3000);
	};

	handleErrors = () => {
		this.setState({ loading: false }, () => {
			const errors = PackagesDataStore.getErrors();
			// console.log('errors from store', errors);
			if (Object.keys(errors).length > 0) {
				const placementErrors = errors;
				const type = "create package";
				this.setState({ errors: placementErrors, showErrors: true }, () => {
					// console.log(this.state);
					ErrorHelpers.displayErrors(formEl, this.state.errors, type);
					showToast("workbookToasts", <ToastNotification type={TOAST_TYPE.ERROR} message="Package could not be added. Please try again or contact support." />);
				});
			}
		});
	};

	/* Needed for all Modals */
	triggerOpenClose = (event) => {
		if (this.state.loading === false) {
			ModalHelpers.openClose(event, this.updateModalState, this.state, initialState, () => {
				if (!this.state.open) {
					UpdateStateHelper.matchParentValues(this, this.props.config);
					this.isValidFormData();
				}
				ErrorHelpers.resetErrors(formEl);
			});
		}
	};

	updateModalState = () => {
		this.setState({ open: !this.state.open, ...initialState });
	};
	/* END */

	handleReset = () => {
		ErrorHelpers.resetErrors(formEl);
	};

	setInitialFormData = () => {
		this.handleReset();
		const configObjs = Object.entries(this.props.config);
		for (const dataBucket of configObjs) {
			if (dataBucket[0] != "ChildData") {
				for (const field of dataBucket[1]) {
					if (field.Name && field?.FieldType != "Hidden") {
						this.state.formData[field.Name] = { disabled: false, parentName: null, value: "" };
					}
				}
			}
		}
	};

	isValidFormData = () => {
		const { formData } = this.state;
		let isValid = true;
		if (Object.keys(this.state.formData).length === 0) {
			isValid = false;
			if (this.props.config) {
				this.setInitialFormData();
			}
		}
		for (const key in formData) {
			if (Object.hasOwn(formData, key)) {
				const { value } = formData[key];
				const isDisabled = formData[key].disabled;
				if (["Rate", "Cost", "PlannedUnits"].includes(key) && ["Flat", "Free", "Added Value"].includes(formData.RateType?.value?.label)) {
					if ((value === "" || value == null || value == undefined) && !isDisabled) {
						isValid = false;
					} else {
						continue;
					}
				}
				if ((value == "" || value == null || value == undefined || value == "0.00") && !isDisabled) {
					isValid = false;
				}
			}
		}

		if (this.state.isFormDataValid !== isValid) {
			this.setState({ isFormDataValid: isValid });
		}
	};

	updateState = (dataConfig, name, value, id, dataType, calc) => {
		if (this.state.loading === false) {
			UpdateStateHelper.update(dataConfig, name, value, id, dataType, calc, formEl, this, false, this.props.config, false, this.isValidFormData);
		}
	};

	sortTaxonomyData = (taxonomyData) => {
		const taxDataWithPositions = taxonomyData;
		taxDataWithPositions.forEach((taxonomyField) => {
			if (this.props.config.TaxonomyData) {
				this.props.config.TaxonomyData.forEach((taxFieldConfig) => {
					if (taxFieldConfig.ID === taxonomyField.dataKeyID) {
						taxonomyField.Position = taxFieldConfig.Position;
					}
				});
			}
		});
		taxDataWithPositions.sort((a, b) => {
			if (a.Position < b.Position) {
				return -1;
			}
			if (a.Position > b.Position) {
				return 1;
			}
			return 0;
		});
		taxDataWithPositions.forEach((taxonomyField) => {
			delete taxonomyField.Position;
		});
		return taxDataWithPositions;
	};

	/* This should be a helper object that formats POST JSON for the PUT Actions */
	formDataObjForPost = (newRowObj) => {
		if (Object.keys(newRowObj).length > 0) {
			const postData = { ...this.state.postData };
			let strippedTaxonomyPostData = [];

			/* Removes the Key from the Taxonomy Data Array : Theja's Post does not like it */
			for (const i in postData.TaxonomyData) {
				strippedTaxonomyPostData.push(postData.TaxonomyData[i]);
			}
			strippedTaxonomyPostData = this.sortTaxonomyData(strippedTaxonomyPostData);
			const strippedMetadataPostData = [];
			for (const i in postData.MetaData) {
				strippedMetadataPostData.push(postData.MetaData[i]);
			}
			postData.MetaData = strippedMetadataPostData;
			/* postData is a copy of the state, so we just overwrite the innards with our new array */
			postData.TaxonomyData = strippedTaxonomyPostData;
			const filters = BookFiltersStore.getChoicesState();
			const campaignUniqueID = MasterCampaignsStore.getParentCampaignUniqueID();
			// const MasterUniqueCodeID = MasterCampaignsStore.getMasterUniqueID();
			/* Config will hold the ID's of the filters */
			if (postData.PackageData) {
				postData.PackageData.MasterCampaignID = this.props.metaData.MasterCampaignID;
				postData.PackageData.CampaignID = this.props.metaData.CampaignUniqueIDCode;
				if (this.props.metaData.Budget === null || this.props.metaData.Budget === 0) {
					postData.PackageData.Cost = 0;
				}
				// postData.PackageData.UniqueID = this.props.metaData.UniqueID;
			} else if (!postData.PackageData) {
				postData.PackageData = {};
				postData.PackageData.MasterCampaignID = this.props.metaData.MasterCampaignID;
				postData.PackageData.CampaignID = this.props.metaData.CampaignUniqueIDCode;
				if (this.props.metaData.Budget === null || this.props.metaData.Budget === 0) {
					postData.PackageData.Cost = 0;
				}
			}

			const contextValues = BookFiltersStore.getContextValues();

			const PlatformID = filters.platform.value;
			const AuditLevelID = this.props.auditLevelID;
			// const auditlevelID = filters.auditlevel.value;
			// const formSubmissionObj = {
			// 	MasterAgencyDivisionID: AgencyID,
			// 	MasterClientID: ClientID,
			// 	CountryID,
			// 	PlatformID,
			// 	AuditLevelID,
			// 	RegionID,
			// 	CampaignUniqueIDCode: campaignUniqueID,
			// 	// add here
			// 	...postData
			// };

			const formSubmissionObj = {
				MasterAgencyDivisionName: contextValues?.agency?.name,
				MasterBusinessUnitName: contextValues?.client?.name,
				MasterCountryCode: contextValues?.country?.name,
				ContextID: contextValues.contextId,
				PlatformID,
				AuditLevelID,
				MasterRegionCode: contextValues?.region?.name,
				CampaignUniqueIDCode: campaignUniqueID,
				...postData
			};

			formSubmissionObj.PackageData.PackageType = this.props.isProgrammatic ? "Programmatic" : "Standard";
			return [formSubmissionObj];
		}
		this.setState({ errors: { Errors: ["Please fill in all form fields."] }, showErrors: true }, () => {
			ErrorHelpers.displayErrors(formEl, this.state.errors);
		});
	};

	sendPostObject = (newRowObj) => {
		this.postObject = this.formDataObjForPost(newRowObj);
		if (this.postObject) {
			const updatedData = putPackages(this.postObject, false);
		}
		if (this.postObject === undefined) {
			this.setState({ loading: false });
		}
	};

	sendPostObjectForCreateAnother = (newRowObj) => {
		this.postObject = this.formDataObjForPost(newRowObj);
		if (this.postObject) {
			putPackages(this.postObject, true);
		}
		if (this.postObject === undefined) {
			this.setState({ loading: false });
		}
	};

	handleSubmit = (e) => {
		if (this.state.loading === false) {
			this.setState({ loading: true }, () => {
				e.preventDefault();
				/* Server Side Validation */
				this.sendPostObject(this.state.formData);
			});
		}
	};

	createAnother = (e) => {
		if (this.state.loading === false) {
			this.setState({ loading: true }, () => {
				e.preventDefault();
				// console.log('createAnother has a console: ', this);
				/* Server Side Validation */
				this.sendPostObjectForCreateAnother(this.state.formData);
			});
		}
	};

	updateCalculatedField = (value) => {
		this.setState({ valueToCalculate: value });
	};

	render() {
		const addChild = `Save and Add ${this.props.childName}`;
		/* Temp Test Function -- Loads a skeleton if nothing there yet */
		const isDisabled = this.state.loading ? "disabledModal" : "";
		let formInnards;
		if (this.props.config) {
			if (Object.keys(this.props.config).length !== 0) {
				formInnards = (
					<FormBuilderV2
						type="create package"
						data={this.props.config}
						configName="packagesConfig"
						onUpdate={this.updateState}
						state={this.state}
						updateCalculatedField={this.updateCalculatedField}
						formEl={formEl}
						parentRef={this}
						metaData={this.props.metaData}
						auditLevelID={this.props.auditLevelID}
					/>
				);
			} else {
				formInnards = (
					<div>
						<TextInputSkeleton />
						<br />
						<TextInputSkeleton hideLabel />
					</div>
				);
			}
		}

		const footer = document.getElementsByClassName("bx--modal-footer").innerHTML;

		return (
			<>
				<Modal
					id={formEl}
					heading="Add Package"
					description={`Complete the form to create a ${this.props.isProgrammatic ? "Programmatic" : ""} Package. Choose 'Add Package' to save, or 'Save and Add Placement' to continue with placements.`}
					isOpen={this.state.open}
					onRequestClose={() => {
						if (this.state.open) {
							this.triggerOpenClose();
						}
					}}
					size="medium"
					userClosable={true}
					onClick={() => {}}
					actionSetProps={{
						actionsLeft: (
							<Button className="first-button" display="secondary" onClick={this.triggerOpenClose} data-tracking-id-alt="cancel-add-package">
								Cancel
							</Button>
						),
						actionsRight: (
							<>
								<Button
									className="second-button"
									display="secondary"
									disabled={!this.state.isFormDataValid}
									onClick={this.createAnother}
									data-tracking-id-alt="create-add-another-package"
								>
									{addChild}
								</Button>
								<Button
									className="third-button"
									display="primary"
									disabled={!this.state.isFormDataValid}
									onClick={this.handleSubmit}
									data-tracking-id-alt="confirm-add-package"
								>
									Add
								</Button>
							</>
						)
					}}
				>
					{this.state.loading ? (
						<Loading className="modalLoading" />
					) : (
						<form autoComplete="off">
							<div className="form__group__container _m-t--10 _m-b--10">{formInnards}</div>
							{this.state.showErrors && <div id="errors__container" />}
						</form>
					)}
				</Modal>
			</>
		);
	}
}

export default CreatePackage;
